module.exports = __webpack_public_path__ + "img/austria-pneumonia-male.ebf28e91.png";